import { BodyOnlyPageTemplate } from "./BodyOnlyPageTemplate";
import { CartPageTemplate } from "./CartPageTemplate";
import { CheckoutConfirmationPageTemplate } from "./CheckoutConfirmationPageTemplate";
import { ContentPage1PageTemplate } from "./ContentPage1PageTemplate";
import { ContentST4PageTemplate } from "./ContentST4PageTemplate";
import { ContentStreamPageTemplate } from "./ContentStreamPageTemplate";
import { ForkPageTemplate } from "./ForkPageTemplate";
import { HomePagePageTemplate } from "./HomePagePageTemplate";
import { ProductGroupPageTemplate } from "./ProductGroupPageTemplate";
import { ProductListPageTemplate } from "./ProductListPageTemplate";
import { ProductPageTemplate } from "./ProductPageTemplate";
import { QuoteConfirmationPageTemplate } from "./QuoteConfirmationPageTemplate";
import { QuoteCartPageTemplate } from "./QuoteCartPageTemplate";
import { SalesCampaignPageTemplate } from "./SalesCampaignPageTemplate";
import { SimpleContentPageTemplate } from "./SimpleContentPageTemplate";
import { StaticContentPageTemplate } from "./StaticContentPageTemplate";
import type { PageTemplateComponent } from "./pageTemplateTypes";

export const BODY_ONLY_TEMPLATE_UIDS = [
  "ABMonitorPageTemplate",
  "AccountSettingsPageTemplate",
  "AffiliateDatasheetDownloadPageTemplate",
  "BearingFrequencyCalculatorPageTemplate",
  "CompletePublicRegistrationPageTemplate",
  "ConfirmationPageTemplate",
  "ContactUsPageTemplate",
  "ContractDetailsPageTemplate",
  "ContractOverviewPageTemplate",
  "DigitalServicePageTemplate",
  "FreeCapacityCockpitPageTemplate",
  "GenericReactPageTemplate",
  "GenericEmbeddedReactPageTemplate",
  "LinearConfigurationRequestQuoteConfirmationPageTemplate",
  "LoginPageTemplate",
  "MyCompanyPageTemplate",
  "MediaLibraryPageTemplate",
  "MyAccountPageTemplate",
  "NewContractPageTemplate",
  "CreateContractPageTemplate",
  "NotificationSettingsPageTemplate",
  "NotificationsPageTemplate",
  "OrganizationManagementPageTemplate",
  "OrderHistoryPageTemplate",
  "OrderDetailPageTemplate",
  "OrderAndQuoteSettingsPageTemplate",
  "UpdatePasswordPageTemplate",
  "QuoteDetailPageTemplate",
  "QuoteSearchPageTemplate",
  "PublicRegistrationConfirmationPageTemplate",
  "PublicRegistrationPageTemplate",
  "ImportLinearPageTemplate",
  "ImportLinearConfigPageTemplate",
  "ProductConfigurationTemplate",
  "SelectAccountPageTemplate",
  "SelfRegistrationFormPageTemplate",
  "SelfRegistrationPageTemplate",
  "ShareLinearConfigurationsConfirmationPageTemplate",
  "ShareWishlistConfirmationPageTemplate",
  "StcFinderPageTemplate",
  "StoreFinderPageTemplate",
  "SalesPartnerStep2PageTemplate",
  "SalesPartnerStep3PageTemplate",
  "SalesPartnerWishlistConfirmationPageTemplate",
  "ScanDMCPageTemplate",
  "WishListPageTemplate",
  "ProductComparisonPageTemplate",
  "SelectionAssistantPageTemplate",
  "HousingSelectionAssistantPageTemplate",
  "CompanyPageTemplate",
] as const;

const registry = new Map<string, PageTemplateComponent>();

export function registerPageTemplate(templateUid: string, component: PageTemplateComponent): void {
  registry.set(templateUid, component);
}

export function getPageTemplate(templateUid: string): PageTemplateComponent | undefined {
  return registry.get(templateUid);
}

BODY_ONLY_TEMPLATE_UIDS.forEach((uid) => registerPageTemplate(uid, BodyOnlyPageTemplate));

registerPageTemplate("SalesCampaignPageTemplate", SalesCampaignPageTemplate);
registerPageTemplate("OrderConfirmationPageTemplate", CheckoutConfirmationPageTemplate);
registerPageTemplate("CartPageTemplate", CartPageTemplate);
registerPageTemplate("QuotePageTemplate", QuoteCartPageTemplate);
registerPageTemplate("QuoteConfirmationPageTemplate", QuoteConfirmationPageTemplate);
registerPageTemplate("MultiStepCheckoutSummaryPageTemplate", BodyOnlyPageTemplate);
// Category + PLP share the productListPage.jsp structure: one implementation,
// two real backend templateUid keys.
registerPageTemplate("CategoryPageTemplate", ProductListPageTemplate);
registerPageTemplate("PlpPageTemplate", ProductListPageTemplate);
registerPageTemplate("ProductPageTemplate", ProductPageTemplate);
// Search family: the React SearchPage handles list/grid(tabular)/empty states
// internally, so both deployed search-result CMS templates are body-only.
registerPageTemplate("SearchResultsListPageTemplate", BodyOnlyPageTemplate);
registerPageTemplate("SearchResultsEmptyPageTemplate", BodyOnlyPageTemplate);
registerPageTemplate("LandingPage2Template", HomePagePageTemplate);
registerPageTemplate("HomePageTemplate", HomePagePageTemplate);
// Not-found page: ErrorPageTemplate binds only the shared global chrome slots
// (SiteLogo/Footer/NavigationBar/...) — no page-body components (task 0182 CMS audit) —
// so it renders as a body-only shell with the not-found intent carried as a toast.
registerPageTemplate("ErrorPageTemplate", BodyOnlyPageTemplate);

// Catch-all content-page templates opened by the audited rollout in tasks 0162-0165.
registerPageTemplate("ContentPageST4Template", ContentST4PageTemplate);
registerPageTemplate("ContentPage1Template", ContentPage1PageTemplate);
registerPageTemplate("ProductGroupPageTemplate", ProductGroupPageTemplate);
registerPageTemplate("SimpleContentPageTemplate", SimpleContentPageTemplate);
registerPageTemplate("StaticContentPageTemplate", StaticContentPageTemplate);
registerPageTemplate("ContentStreamPageTemplate", ContentStreamPageTemplate);
registerPageTemplate("ForkPageTemplate", ForkPageTemplate);
